import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Button, Skeleton, Table, Tag } from 'antd';

import Truncate from 'v2/components/Shared/TruncateText';
import { useClickNewzz } from 'v2/hooks/useClickNewzz';
import { useListNewzz } from 'v2/hooks/useListNewzz';

const ITEMS_LIMIT = 8;

function News() {
  const { newzzList, isLoading } = useListNewzz(ITEMS_LIMIT);
  const { clickNewzz } = useClickNewzz();
  const isInitialLoading = isLoading && newzzList.length === 0;
  const isEmpty = !isLoading && newzzList.length === 0;
  const hasNewTag = newzzList.some(item => item.show_tag_new);

  const columns: React.ComponentProps<typeof Table>['columns'] = [
    {
      dataIndex: 'title',
      className: 'p-4!',
      render: (_: any, item: any) =>
        item.has_content ? (
          <RouterLink
            to={`news/info/${item.id}`}
            onClick={() => clickNewzz(item.id)}
            aria-label={`Abrir notícia: ${item.title}`}
          >
            <Truncate count={50} final='...'>
              {item.title}
            </Truncate>
          </RouterLink>
        ) : (
          <a
            href={item.external_url}
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => clickNewzz(item.id)}
            aria-label={`Abrir link externo: ${item.title}`}
          >
            <Truncate count={50} final='...'>
              {item.title}
            </Truncate>
          </a>
        )
    },
    {
      dataIndex: 'show_tag_new',
      width: 80,
      align: 'right' as const,
      hidden: !hasNewTag,
      render: (_: any, item: any) => (item.show_tag_new ? <Tag>NOVO</Tag> : null)
    }
  ];

  return (
    <div className='h-full min-h-[430px] rounded-sm bg-white shadow-sm'>
      <h4 className='mb-4 flex flex-wrap items-center justify-between gap-2 p-4 text-lg font-semibold'>Newzz</h4>

      {isInitialLoading ? (
        <div className='p-4'>
          {Array.from({ length: ITEMS_LIMIT }).map((_, i) => (
            <Skeleton key={`sk-${i}`} active paragraph={false} className='mb-2' />
          ))}
        </div>
      ) : isEmpty ? (
        <div className='p-4'>
          <span className='text-gray-500' style={{ minHeight: 35 }}>
            Nenhuma novidade no momento.
          </span>
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={newzzList}
          rowKey='id'
          pagination={false}
          size='small'
          showHeader={false}
        />
      )}

      {!isInitialLoading && newzzList.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 16, marginTop: 'auto' }}>
          <RouterLink to='/producer/news'>
            <Button type='text' disabled={isLoading} aria-label='Ver mais novidades'>
              Ver mais novidades
            </Button>
          </RouterLink>
        </div>
      )}
    </div>
  );
}

export default News;
